import { CurrencyEnum } from "../../../../shared/models";

export class ClientDetails {
  clientId: number;
  clientName: string;
  billingCurrency: CurrencyEnum
}
